import $ from 'jquery';
import './accordion';
import './carousel';
import './slideshow';
import './team';
import showElements from './onshow-elements';
import loadElements from './ajax-loader';

window.loadElements = loadElements;
$( () => {
    showElements('.animate');
	const hero = $('.hero');
	const heroOverlay = hero.find('.hero-overlay');
	const nav = $('.nav');
	const body = $('html, body');
	if (hero.length && heroOverlay.length && nav.length) {
		body.addClass('fixed');
		setTimeout(function() {
			hero.addClass('hero--animate');
			nav.addClass('nav--animate');
		}, 500);
		setTimeout(function() {
			body.removeClass('fixed');
		}, 3500);
		setTimeout(function() {
			$('#ccm-widget, .ccm-settings-summoner').fadeIn();
		}, 4500);
	} else {
		setTimeout(function() {
			$('#ccm-widget, .ccm-settings-summoner').fadeIn();
		}, 500);
	}
	const hamburger = nav.find('.nav-hamburger');
	const mainnavItems = nav.find('.nav-items--level-1 > .nav-item--deep');
	if (hamburger.length) {
		hamburger.on('click', function(ev) {
			ev.preventDefault();
			nav.toggleClass('nav--opened');
			body.toggleClass('fixed');
			mainnavItems
				.removeClass('nav-item--active')
				.find('.nav-items--level-2').slideUp();
		});
		mainnavItems.on('click', function(ev) {
			if (hamburger.is(':visible')) {
				if ($(ev.target).closest('.nav-items--level-2').length === 0) {
					ev.preventDefault();
					$(this)
						.toggleClass('nav-item--active')
						.find('.nav-items--level-2').slideToggle();
					$(this).siblings('.nav-item')
						.removeClass('nav-item--active')
						.find('.nav-items--level-2').slideUp();
				}
			}
		});
		nav.on('click', '[href^="#"]', function(ev) {
			nav.removeClass('nav--opened');
			body.removeClass('fixed');
			if (hamburger.is(':visible')) {
				$('.nav-items--level-2').slideUp().find('.nav-item')
					.removeClass('nav-item--active');
			}
		})
	}
	if (nav.length) {
        const heroSection = document.querySelector('.hero');
        let nextSection;
        if (heroSection) {
            nextSection = heroSection.nextElementSibling;
            while (nextSection && nextSection.offsetHeight === 0) {
                nextSection = nextSection.nextElementSibling;
            }
        }
        const navHeight = document.querySelector('.nav-outerwrapper').offsetHeight;
        const offsetHeight = window.innerHeight - navHeight;
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                        nav.addClass('nav--sticky');
                    } else {
                        nav.removeClass('nav--sticky');
                    }
                });
            },
            {
                root: null,
                rootMargin: `${offsetHeight}px 0px -${offsetHeight}px 0px`,
                threshold: 0
            }
        );
        if (nextSection) {
            observer.observe(nextSection);
        } else {
            nav.classList.add('nav--sticky');
        }
	}
	$(document).on('mouseenter pointerenter', '.button', function() {
		let parent = $(this).closest('.button-wrapper');
		for(var i = 0; i < this.classList.length; i++) {
			if (this.classList[i].startsWith('button--')) {
				var newClass = this.classList[i].substring(8, this.classList[i].length);
				parent.addClass('button-wrapper--'+newClass+'-hover');
			}
		}
	}).on('mouseleave pointerleave', '.button', function() {
		var parent = $(this).closest('.button-wrapper');
		for(var i = 0; i < this.classList.length; i++) {
			if (this.classList[i].startsWith('button--')) {
				var newClass = this.classList[i].substring(8, this.classList[i].length);
				parent.removeClass('button-wrapper--'+newClass+'-hover');
			}
		}
	});

});
